import { Alert } from "@mui/material";

interface EmptyTotalsBlocksBannerProps {
  /** Names of totals blocks that have no coverages rolling up to them. */
  blockNames: string[];
}

/**
 * Caution banner shown above the financials grid when one or more totals
 * blocks have no coverages assigned, so the analyst can fix the
 * misconfiguration before presenting to the broker.
 */
export const EmptyTotalsBlocksBanner = ({
  blockNames,
}: EmptyTotalsBlocksBannerProps): React.JSX.Element | null => {
  if (blockNames.length === 0) return null;

  return (
    <Alert
      severity="warning"
      data-testid="financials-empty-blocks-warning"
      sx={{ mb: 2 }}
    >
      {`The following Total Block(s) do not have any premium roll-ups: ${blockNames.join(", ")}`}
    </Alert>
  );
};
